import { render } from "./CostLimitListView.vue?vue&type=template&id=0252636c&scoped=true"
import script from "./CostLimitListView.vue?vue&type=script&lang=js"
export * from "./CostLimitListView.vue?vue&type=script&lang=js"

import "./CostLimitListView.vue?vue&type=style&index=0&id=0252636c&scoped=true&lang=css"

import exportComponent from "/builds/swisscom/messaging/web-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0252636c"]])

export default __exports__